document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("contact_form");
    const submitButton = document.querySelector("#contact_form button[type='submit']");

    if (!form || !submitButton) return;

    submitButton.addEventListener("click", function (event) {
        event.preventDefault(); 

        let isValid = true;

        const nameField = document.querySelector("input[name='contact[name]']");
        const emailField = document.querySelector("input[name='contact[email]']");
        const messageField = document.querySelector("textarea[name='contact[body]']");


        document.querySelectorAll(".error-message").forEach(el => el.remove());

        if (nameField.value.trim() === "") {
            showError(nameField, "Name is required.");
            isValid = false;
        }

        if (!validateEmail(emailField.value)) {
            showError(emailField, "Please enter a valid email.");
            isValid = false;
        }

        if (messageField.value.trim().length < 10) {
            showError(messageField, "Message must be at least 10 characters long.");
            isValid = false;
        }

        if (isValid) {
            form.submit();
        }
    });


    function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }


    function showError(input, message) {
        const error = document.createElement("p");
        error.className = "error-message";
        error.style.color = "red";
        error.style.fontSize = "12px";
        error.textContent = message;
        input.parentNode.appendChild(error);
    }
});

